import React from "react";
import { cn } from "@/lib/utils";

export type CountryCode = "us"; // Extend later as we add more countries

interface CountryBadgeProps {
  code: CountryCode;
  label?: string; // Visual text, defaults to short country code like "US"
  className?: string;
}

const CountryBadge: React.FC<CountryBadgeProps> = ({ code, label, className }) => {
  const codeText = String(code).toUpperCase();
  const text = label ?? (code === "us" ? "US" : codeText);

  // Simple, accessible flag rendering with inline SVG for crisp cross-platform display
  const Flag: React.FC = () => {
    if (code === "us") {
      return (
        <svg
          width="18"
          height="12"
          viewBox="0 0 7410 3900"
          role="img"
          aria-label="United States flag"
          className="shrink-0"
        >
          <rect width="7410" height="3900" fill="#b22234" />
          <g fill="#fff">
            <rect y="300" width="7410" height="300" />
            <rect y="900" width="7410" height="300" />
            <rect y="1500" width="7410" height="300" />
            <rect y="2100" width="7410" height="300" />
            <rect y="2700" width="7410" height="300" />
            <rect y="3300" width="7410" height="300" />
          </g>
          <rect width="2964" height="2100" fill="#3c3b6e" />
          <g fill="#fff">
            {Array.from({ length: 9 }).map((_, row) =>
              Array.from({ length: row % 2 === 0 ? 6 : 5 }).map((_, col) => {
                const x = 247 + col * 494 + (row % 2 ? 247 : 0);
                const y = 210 + row * 210;
                return <circle key={`${row}-${col}`} cx={x} cy={y} r="90" />;
              })
            )}
          </g>
        </svg>
      );
    }
    return (
      <span
        role="img"
        aria-label={`${text} flag`}
        className="text-base leading-none"
        title={text}
      >
        🏳️
      </span>
    );
  };

  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full border bg-muted px-2 py-1 text-xs text-foreground",
        className
      )}
    >
      <Flag />
      <span className="font-medium">{text}</span>
    </span>
  );
};

export default CountryBadge;
